import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required. Please set it in your environment variables.');
}

export const apiWithAuth = (token) => {
  console.log('apiWithAuth called with token type:', typeof token);
  console.log('Token received in apiWithAuth:', token);
  
  // Clean the token if it's a string
  let cleanToken = token;
  if (typeof token === 'string') {
    cleanToken = token.replace(/^bearer\s+/i, ''); // Remove any existing 'bearer' prefix
  }
  
  console.log('Cleaned token:', cleanToken);
  
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': `Bearer ${cleanToken}`,
      'Content-Type': 'application/json'
    }
  });
};